// extracted by mini-css-extract-plugin
export var active = "styles-module--active--8fd98";
export var footer = "styles-module--footer--7dc91";
export var isScrollHidden = "styles-module--isScrollHidden--d84ee";
export var menu = "styles-module--menu--03fa3";
export var ps__railY = "styles-module--ps__rail-y--a7833";
export var rotateIcon = "styles-module--rotateIcon--8a587";
export var sectionLink = "styles-module--sectionLink--718e2";
export var sectionLinks = "styles-module--sectionLinks--abe78";
export var sections = "styles-module--sections--39738";
export var sidebarDefaultBullet = "styles-module--sidebarDefaultBullet--3d73f";
export var sidebarLeafBullet = "styles-module--sidebarLeafBullet--d528e";
export var specialIcon = "styles-module--specialIcon--9fb6d";